import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

const UPDATE_EVENT_SCHEDULE_DETAILS = gql`
  mutation UpdateEventScheduleDetails(
    $input: UpdateEventScheduleDetailsInput!
  ) {
    updateEventScheduleDetails(input: $input) {
      id
      about
      schedule_details
      schedule_detail_url
      schedule_detail_image
      schedule_detail_image_id
    }
  }
`;

export function useUpdateEventInfo() {
  const [updateMutation, { loading, error }] = useMutation(
    UPDATE_EVENT_SCHEDULE_DETAILS
  );

  const updateEventInfo = async (input) => {
    try {
      const response = await updateMutation({
        variables: { input },
      });
      return response;
    } catch (err) {
      console.error('Error updating event schedule details:', err);
      throw err;
    }
  };

  return {
    updateEventInfo,
    loading,
    error,
  };
}
